import React from "react"
import { Card, Grid } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { ReactComponent as ProtectIcon } from "uikit/Icons/protect-goal.svg"

const LifeInsurance = ({
  id,
  expenses_coverage,
  goal_coverage,
  covered_goals,
  baseUrl,
  type
}) => {
  const numberOfCoveredGoals =
    goal_coverage === "some" ? covered_goals.length : 0
  return (
    <Card>
      <Card.Content>
        <Link
          to={`${baseUrl}/goals/${id}/${type.toLowerCase()}`}
          className="navlink"
        >
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column verticalAlign="middle" width={4}>
                <ProtectIcon />
              </Grid.Column>
              <Grid.Column>
                <Grid>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <span className="GenericCard__LinkTitle">
                        Protect My Family
                      </span>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2} style={{ paddingTop: "0px" }}>
                    <Grid.Column verticalAlign="bottom">
                      <p
                        className="GoalCard_Price"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {expenses_coverage}%
                      </p>
                      <p className="greyed-text">of living expenses</p>
                    </Grid.Column>
                    <Grid.Column className="GoalCard_Year_Div">
                      <p
                        className="GoalCard_SecondText"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {goal_coverage === "all" ? "All" : numberOfCoveredGoals}
                      </p>
                      <p className="greyed-text">
                        goal{numberOfCoveredGoals !== 1 ? "s" : ""}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Link>
      </Card.Content>
    </Card>
  )
}
export default LifeInsurance
